import { Box, ErrorOutline, Flex, Text, ThumbDownIcon, ThumbUpIcon } from "@shared/primitive-components"
import { rebatesStyles as styles } from "../styles"
import { FeedbackProps } from "../types"

export const getFeedbackProps = (
  hasData: boolean,
  hasPositiveFeedback: boolean,
  label: string,
  omitNoDataTag?: boolean
): FeedbackProps => {
  if (omitNoDataTag && !hasData) return { label: ``, icon: <div />, color: `nodata` }
  if (!hasData) return { label: `No data`, icon: ErrorOutline, color: `nodata` }
  return {
    label,
    icon: hasPositiveFeedback ? ThumbUpIcon : ThumbDownIcon,
    color: hasPositiveFeedback ? `positive` : `negative`,
  }
}

export type StatFeedbackProps = {
  variant?: `summary` | undefined
  bottomComponent?: JSX.Element
  feedback: FeedbackProps
  dataTestIds?: {
    icon?: string
    text?: string
  }
}

export const StatFeedback = ({ variant, bottomComponent, feedback, dataTestIds }: StatFeedbackProps) => (
  <Box css={variant ? styles.statFeedback : styles.marginBottom(4)}>
    <Flex alignItems="center">
      <Box data-testid={dataTestIds?.icon} as="span" css={styles.feedbackIcon(feedback.color)}>
        {feedback.icon}
      </Box>
      <Text tag="span" data-testid={dataTestIds?.text} use={variant ? `body1` : `body2`}>
        {feedback.label}
      </Text>
    </Flex>
    {bottomComponent}
  </Box>
)

StatFeedback.defaultProps = {
  variant: undefined,
  bottomComponent: null,
  dataTestIds: undefined,
}
